export const VNLOADER_SET_SPINNER = 'VNLOADER_SET_SPINNER'
